export default "__VITE_ASSET__CbVZWqVJ__"